import React, { useContext } from 'react';
import AppContextProvider, { AppContext, AppContextTypes } from './AppContext';
import ChatContextProvider, { ChatContext, ChatContextTypes } from "./ChatContext";
import MessageContextProvider, { MessageContext, MessageContextTypes } from "./MessageContext";
import ThemeContextProvider, { ThemeContext, ThemeContextTypes } from "./ThemeContext";

const GlobalState: React.FC = ({children}) => {
  return (
    <AppContextProvider>
      <ChatContextProvider>
        <MessageContextProvider>
          <ThemeContextProvider>
            {children}
          </ThemeContextProvider>
        </MessageContextProvider>
      </ChatContextProvider>
    </AppContextProvider>
  );
}

export function useAppState() {
  const context = useContext<AppContextTypes>(AppContext);
  if (context === undefined) {
    throw new Error('useAppState must be used within a AppContext');
  }
  return context;
}

export function useChatState () {
  const context = useContext<ChatContextTypes>(ChatContext);
  if (context === undefined) {
    throw new Error('useChatState must be used within a ChatContext');
  }
  return context;
}

export function useTheme () {
  const context = useContext<ThemeContextTypes>(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeContext');
  }
  return context;
}

export function useMessageState () {
  const context = useContext<MessageContextTypes>(MessageContext);
  if (context === undefined) {
    throw new Error('useMessageState must be used within a MessageContext');
  }
  return context;
}


export default GlobalState;